/* eslint-disable no-param-reassign */
import { produce } from 'immer';

import { EventsStore } from 'context/events';
import { EventsAction } from 'types/actions/state';

export const eventsReducer = (state: EventsStore, action: EventsAction): EventsStore => {
  switch (action.type) {
    case 'REMOVE_EVENT':
      return produce(state, (draft) => {
        draft.states = draft.states.filter((event) => event.id !== action.payload.eventId);
        draft.count = Math.max(0, draft.count - 1);
      });
    default:
      return state;
  }
};
